import { render, staticRenderFns } from "./addressBankInformation.vue?vue&type=template&id=08adbaaa&"
import script from "./addressBankInformation.vue?vue&type=script&lang=js&"
export * from "./addressBankInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports